jQuery(document).ready(function($){
    if ( $('.nf-insights-slider').length > 0 ) {
        $('.nf-insights-slider .nf-insights-slider__wrapper').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            appendDots: $('.nf-insights-slider__nav'),
            dots: true,
            centerMode: true,
            variableWidth: true,
            infinite: false,
            speed: 500,
            prevArrow: '<div class="nf-insights-slider__prev"><button>←</button></div>',
            nextArrow: '<div class="nf-insights-slider__next"><button>→</button></div>',
            appendArrows: $('.nf-insights-slider__arrows'),
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        infinite: true,
                    }
                }
            ],
        });
        
        let right_padding = 0;
        
        const reposition_slider = () => {
            $('.nf-insights-slider__wrapper').css('margin-left', '');
            
            if ( $(window).width() <= 1300 ) {
                $('.nf-insights-slider__prev').css('left', '');
                $('.nf-insights-slider__next').css('left', '');

                return;
            }

            let title_offset = $('.nf-insights-slider__title').offset().left;
            let active_slide_offset = $('.nf-insights-slider .slick-current.slick-slide').offset().left;
            
            let offset = active_slide_offset > title_offset ? active_slide_offset - title_offset : title_offset - active_slide_offset;
            
            $('.nf-insights-slider__wrapper').css('margin-left', '-' + offset + 'px');
            
            // Arrow positioning
            const arrow_offset_top =  $('.nf-insights-slider__wrapper').position().top + ( $('.nf-insights-slider__wrapper .slick-slide.slick-current img').height() / 2 ) - 20;
            const arrow_offset_next = $('.nf-insights-slider .slick-slide.slick-current').next().offset().left - 25;
            const arrow_offset_prev = $('.nf-insights-slider .slick-slide.slick-current').offset().left - 85;
            
            $('.nf-insights-slider__prev').css('top', arrow_offset_top + 'px');
            $('.nf-insights-slider__next').css('top', arrow_offset_top + 'px');
            
            $('.nf-insights-slider__prev').css('left', arrow_offset_prev + 'px');
            $('.nf-insights-slider__next').css('left', arrow_offset_next + 'px');
        }
        
        reposition_slider();
        
        $(window).resize(function(){
            right_padding = 0;
            reposition_slider();
        });
        
        $('.nf-insights-slider .nf-insights-slider__wrapper').on('setPosition', function(){
            reposition_slider();
        });
    }
});